import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M15.998 20.066a9 9 0 1 0 -3.998 .934v-13","key":"svg-0"}],["path",{"d":"M16 12l-4 -4l-4 4","key":"svg-1"}]]

/**
 * IconCircleOpenArrowUp
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItY2lyY2xlLW9wZW4tYXJyb3ctdXAiCj4KICA8cGF0aCBzdHJva2U9Im5vbmUiIGQ9Ik0wIDBoMjR2MjRIMHoiIGZpbGw9Im5vbmUiIC8+CiAgPHBhdGggZD0iTTE1Ljk5OCAyMC4wNjZhOSA5IDAgMSAwIC0zLjk5OCAuOTM0di0xMyIgLz4KICA8cGF0aCBkPSJNMTYgMTJsLTQgLTRsLTQgNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/circle-open-arrow-up
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconCircleOpenArrowUp = createReactComponent('outline', 'circle-open-arrow-up', 'CircleOpenArrowUp', __iconNode);

export default IconCircleOpenArrowUp;